const daDK = {
  navigation: {
    mydevice: "Min enhed",
    mymobile: "Min mobil"
  },
  photoorganiser: {
    navigation: {
      photos: "Billeder",
      favorites: "Favoritter",
      collections: "Kollektioner",
      events: "Begivenheder",
      latestuploads: "Seneste uploads"
    },
    empty(source) {
      return "Du har ingen billeder i " + source
    }
  },
  mymobile: {
    title: "Hent billederne fra din telefon på et øjeblik!",
    qrcode: {
      title: "Scan QR-koden",
      subtitle: "(Det er ikke nødvendigt at installere appen)"
    },
    instruction: {
      title: "Lad os komme i gang!",
      step_1: "Åben din kameraapp",
      step_2: "Scan QR-koden",
      step_3: "Følg instruktionerne på din mobil"
    }
  },
  layout: {
    flex: "Fleksibel",
    square: "Kvardrat"
  },
  calender: {
    allmonths: "Alle måneder",
    allyears: "Alle år",
    months: {
      january: "Januar",
      february: "Februar",
      march: "Februar",
      april: "April",
      may: "Maj",
      june: "Juni",
      july: "Juli",
      august: "August",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "December"
    }
  },
  generic: {
    sortBy: "sorter efter",
    selected: "udvalgte",
    done: "Tilføj billeder",
    back: "Tilbage",
    images: "billeder",
    removeall: "Fjern alle",
    selection: "Udvalg",
    date: "Dato",
    name: "Navn",
    az: "Filnavn A-Z",
    za: "Filnavn Z-A",
    newestfirst: "Dato fra nyest til ældst",
    oldestfirst: "Dato fra ældst til nyest",
    photos: "billeder",
    all: "Alle",
    yes: "ja",
    no: "no",
    nodate: "Ingen dato"
  },
  rangeText: {
    minMax(min, max) {
      return "Du skal vælge mellem " + min + " og " + max + " billeder"
    },
    min(min) {
      return "Det kræver mindst " + min + " billeder at lave din fotobog."
    },
    max(max) {
      return "Du kan vælge maks. " + max + " billeder"
    }
  },
  addMorePhotos: "Tilføj flere fotos",
  upload: {
    browseButton: "Tilføj fotos",
    uploadlimit(maxSize) {
      return "Billedernes filstørrelse skal være mindre end " + maxSize
    },
    dragImage: "eller træk og slip dine filer her.",
    errors: {
      GENERIC_ERROR: "Noget gik galt. Prøv igen senere, eller kontakt vores kundeservice.",
      EMPTY_FILE: "Billedreferencen er gået tabt, tilføj billedet igen",
      MAX_FILE_SIZE: "Filen skal være mindre end {0} mb",
      UNSUPPORTED_FILE_TYPE: "Filformatet understøttes ikke",
      MAX_IMAGE_RESOLUTION: "Filen skal være mindre end {0} pixels",
      INVALID_IMAGE: "Filen er ødelagt"
    },
    errorSummary(number) {
      return number + " filer kunne ikke uploades"
    },
    errorDialog: {
      headline: "Ups!",
      ingress: "Følgende filer kunne ikke uploades:",
      filenameColumn: "Fil",
      reasonColumn: "Årsag"
    },
    uploaded: "Uploadet",
    estimating: "Estimering af tid",
    estimatedleft: "Anslået tid tilbage",
    ok: "OK",
    cancel: "Annuller",
    details: "Detaljer"
  }
}

export default daDK
